import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const lagenceSizes: string[] = [
  // Tops
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',

  // Dresses/Blazers
  '00',
  '0',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',

  // Jeans/Pants
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',

  // Shoes
  '5 US / 35 EU',
  '5.5 US / 35.5 EU',
  '6 US / 36 EU',
  '6.5 US / 36.5 EU',
  '7 US / 37 EU',
  '7.5 US / 37.5 EU',
  '8 US / 38 EU',
  '8.5 US / 38.5 EU',
  '9 US / 39 EU',
  '9.5 US / 39.5 EU',
  '10 US / 40 EU',
  '10.5 US / 40.5 EU',
  '11 US / 41 EU',
  '12 US / 42 EU',
];

export const lagenceShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: lagenceSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '7e637585fcd34e8a9df205dbee4bf9fe',
      [BuilderSections.AboutPageHeroContent]: 'bc866e00d8c343b6b5c47515e777a29c',
      [BuilderSections.AboutPageInfoTabContent]: 'dc32f80563c94705a4f71abea4ad1a2d',
      [BuilderSections.AboutPageNavbarContent]: '469dc121d91341fd84e0637e99cfa688',
      [BuilderSections.FooterContent]: '23158e0ed38e40f2a64cf6a5f7177c36',
      [BuilderSections.TopbarContent]: '146e37bece254f3880aab7f3d1bcff59',
      [BuilderSections.TopbarMobileContent]: '7de9d698cc084f53aba2c66c23945aed',
    },
  },
};
